<template>
  <div>
    <v-container container--fluid grid-list-xl>
      <v-row align="center">
        <v-col cols="12" md="6" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1>Create delivery</h1>
        </v-col>
        <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
        <v-col cols="12" md="3">
          <v-autocomplete
            hide-no-data
            v-if="this.isInternalUser"
            v-model="clientId"
            :items="clientsRendered"
            item-text="name"
            item-value="id"
            label="Choose the Client"
            auto-select-first
            :menu-props="{transition: 'slide-x-transition'}"
            @input="getTimeWindows"
            @change="() => {if (selectedClientObject && selectedClientObject.name === 'HelloFresh NZ') country = 'NZL'; else country = 'AUS';}"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            hide-no-data
            v-model="postcode"
            label="Choose the Postcode"
            :menu-props="{transition: 'slide-x-transition'}"
            @input="getTimeWindows"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card color="#42424211">
          <v-card-title>Creation option</v-card-title>
          <v-container>
            <v-col v-for="parts in creationOption" :key="parts.partName" :class="$vuetify.breakpoint.smAndDown ? 'py-0':''">
              <div v-if="$vuetify.breakpoint.smAndDown" style="width: 100%; display: flex; justify-content: center">
                <v-subheader class="font-weight-black">{{parts.partName}}</v-subheader>
              </div>
              <v-row v-for="(items, key) in parts.items" :key="key + parts.partName">
                <div v-if="$vuetify.breakpoint.mdAndUp" style="flex: 1; display: flex; ">
                  <v-subheader class="font-weight-black" v-if="key==0">{{parts.partName}}</v-subheader>
                </div>
                <div style="flex: 5; display: flex; flex-wrap: nowrap">
                  <div v-for="item in items" :key="item.text" style="flex: 1" class="px-2">
                    <DatePicker
                      ref="date"
                      v-if="item.inputType ==='date' && item.id !== 'production_date'"
                      :label="item.text"
                      :date_props="date"
                      :filled="true" :outlined="true" :dense="true"
                      :disabled="selectedClient === null || !postcode"
                      :rules="[v => !!v || item.text + ' is required']"
                      :allowedDates="allowedDates"
                      @interface="(event) => date = event"
                    ></DatePicker>
                    <DatePicker
                      v-else-if="item.id === 'production_date'"
                      ref="production_date"
                      label="Production date"
                      :date_props="production_date"
                      filled outlined dense
                      @interface="(event) => production_date = event"
                      :rules="[v => !!v || item.text + ' is required']"
                    ></DatePicker>
                    <v-text-field
                      v-else-if="item.inputType ==='text' || item.inputType ==='number'"
                      :type="item.inputType"
                      :outlined="item.text !== 'Postcode'"
                      dense
                      :filled="item.text !== 'Postcode'"
                      :readonly="item.text === 'Postcode'"
                      :flat="item.text === 'Postcode'"
                      v-model="item.text === 'Postcode' ? postcode : item.value"
                      :label="item.text"
                      :hint="item.hint"
                      :rules="item.required ? [v => !!v || item.text + ' is required'] : []"
                      :disabled="item.text === 'Postcode'"
                    ></v-text-field>
                    <v-switch
                      v-else-if="item.inputType ==='switch'"
                      dense
                      v-model="item.value"
                      :label="item.text"
                      :rules="item.required ? [v => !!v || item.text + ' is required'] : []"
                      :disabled="selectedClient === null || !postcode"
                      class="ma-1"
                    ></v-switch>
                    <v-autocomplete
                      v-else-if="item.id ==='timeWindow'"
                      outlined dense filled
                      v-model="item.value"
                      :items="renderedAvailableTimeWindows"
                      return-object
                      item-text="display"
                      :label="item.text"
                      :hint="item.hint"
                      :rules="item.required ? [v => !!v || item.text + ' is required'] : []"
                      :disabled="selectedClient === null || !postcode"
                    ></v-autocomplete>
                    <v-autocomplete
                      v-else-if="item.id ==='state'"
                      outlined dense filled
                      v-model="item.value"
                      :items="states[country]"
                      item-text="name"
                      item-value="id"
                      :label="item.text"
                      :hint="item.hint"
                      :rules="item.required ? [v => !!v || item.text + ' is required'] : []"
                      :disabled="country === null"
                    ></v-autocomplete>
                    <v-autocomplete
                      v-else-if="item.id ==='service_id'"
                      outlined dense filled
                      v-model="item.value"
                      :items="renderedServices"
                      item-text="name"
                      item-value="id"
                      :label="item.text"
                      :hint="item.hint"
                      :rules="item.required ? [v => !!v || item.text + ' is required'] : []"
                      :disabled="selectedClient === null || !postcode"
                    ></v-autocomplete>
                    <v-autocomplete
                      v-else-if="item.id ==='consolidation_depot'"
                      outlined dense filled
                      v-model="consolidation_depot_id"
                      :items="renderedDepots"
                      item-text="name"
                      item-value="id"
                      label="Consolidation depot"
                  ></v-autocomplete>
                  <v-autocomplete
                      v-else-if="item.id ==='country' && selectedClientObject && selectedClientObject.name !== 'HelloFresh NZ'"
                      outlined dense filled
                      v-model="country"
                      :items="countries"
                      item-text="name"
                      item-value="id"
                      label="Country"
                  ></v-autocomplete>
                  <v-text-field
                      v-else-if="item.id ==='country' && selectedClientObject && selectedClientObject.name === 'HelloFresh NZ'"
                      dense
                      readonly
                      flat
                      :label="item.text"
                      :hint="item.hint"
                      :value="countries.find(c => c.id === country).name"
                      disabled
                    ></v-text-field>
                    <v-textarea
                      v-else-if="item.inputType ==='textarea'"
                      outlined dense filled
                      v-model="item.value"
                      :label="item.text"
                      :hint="item.hint"
                      :rules="item.required ? [v => !!v || item.text + ' is required'] : []"
                      :disabled="selectedClient === null || !postcode"
                    ></v-textarea>
                    <v-col v-else-if="item.inputType=='tags'">
                      <v-row justify="space-around">
                        <v-col cols="12">
                          <v-btn
                            @click="addItemDialog = true"
                            block primary
                            color="rgba(10,140,190,0.7)"
                            style="color:#FFFFFF"
                            :disabled="selectedClient === null || !postcode"
                          >
                            <v-icon left>add</v-icon> Add tags
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table
                        :headers="tagHeaders"
                        :items="tagsList"
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-btn icon @click="editTag(item)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn icon @click="deleteTag(item)">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-col>
                  </div>
                </div>
              </v-row>
            </v-col>
          </v-container>
        </v-card>

        <v-row justify="space-around">
          <v-col cols="10">
            <v-btn
              @click="createDelivery"
              block primary
              color="primary"
              :disabled="!valid || selectedClient === null || !postcode"
            >
              Create delivery
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-dialog v-model="addItemDialog" @close="closeDialog">
      <v-card>
        <v-card-title>
          <h2>{{this.isEditing ? 'Edit tag': 'Create new tag'}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="align-center">
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="newTag.number"
                  label="Serial"
                  :rules="[v => !!v || 'Serial is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="newTag.quantity"
                  label="Quantity"
                  type="number"
                  :rules="[v => !!v || 'Quantity is required', v => v > 0 || 'Quantity must be greater than 0']"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="newTag.item"
                  label="(Optional) Name of a tag / additional info"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  v-model="newTag.description"
                  label="(Optional) Description of a tag"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions class="justify-center">
              <v-btn :disabled="!newTag.number" text @click="saveChanges">Save</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog with basic info of successfully created delivery  -->
    <v-dialog v-model="deliveryCreated" max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Delivery created successfully
          <i class="fas fa-check-circle ml-2" style="color: green;"></i>
        </v-card-title>
        <v-card-text>
          <h5>Tracking: <b>{{createdTracking}}</b></h5>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Dialog actions -->
          <v-btn color="blue darken-1" text @click="createNewDelivery()">Create new delivery</v-btn>
          <v-btn color="green darken-1" text @click="goToCreatedDelivery()">go to created delivery</v-btn>
          <v-btn color="blue darken-1" text @click="deliveryCreated=false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from "axios";
  import DatePicker from "../../../parts/DatePicker";

  export default {
    name: "CreateDelivery",
    components: {
      DatePicker,
    },
    data () {
      return {
        clientId: null,
        postcode: null,
        creationOption: [
          {
            partName: 'Contact',
            items: [
              [
                {id: 'name', text: 'Name', value: null, inputType: 'text', required: true},
                {id: 'invoice', text: 'Invoice', value: null, inputType: 'text'},
              ],
              [
                {id: 'phone1', text: 'Phone', value: null, inputType: 'number'},
              ]
            ]
          },
          {
            partName: 'Location',
            items: [
              [
                {id: 'country', text: 'Country', value: null, inputType: 'autocomplete'},
              ],
              [
                {id: 'street1', text: 'Street 1', value: null, inputType: 'text', required: true},
                {id: 'street2', text: 'Street 2', value: null, inputType: 'text'},
              ],
              [
                {id: 'suburb', text: 'Suburb', value: null, inputType: 'text', required: true},
                {id: 'postcode', text: 'Postcode', value: null, inputType: 'number', required: true},
                {id: 'state', text: 'State', value: null, inputType: 'autocomplete', required: true},
              ]
            ]
          },
          {
            partName: 'Time',
            items: [[
              {id: 'date', text: 'Date', value: null, inputType: 'date', required: true},
              {id: 'timeWindow', text: 'Time-window', value: null, inputType: 'autocomplete', required: true}
            ]]
          },
          {
            partName: 'Options',
            items: [
              [
                {id: 'service_id', text: 'Service id', value: null, inputType: 'autocomplete', required: true},
                {id: 'consolidation_depot', text: 'Consolidation depot', value: null, inputType: 'autocomplete'},
                {id: 'production_date', text: 'Production Date', value: null, inputType: 'date', required: true},
              ],
              [
                {id: 'instructions', text: 'Instructions', value: null, inputType: 'textarea'},
              ],
              [
                {id: 'tags', text: 'Tags', value: null, inputType: 'tags'},
              ]
            ]
          },
        ],
        date: null,
        consolidation_depot_id: null,
        production_date: null,
        country: null,
        countries: [
          {id: 'AUS', name: 'Australia'},
          {id: 'NZL', name: 'New Zealand'},
        ],
        states: {
          AUS: [
            { id: 'NSW', name: 'New South Wales' },
            { id: 'VIC', name: 'Victoria' },
            { id: 'QLD', name: 'Queensland' },
            { id: 'SA',  name: 'South Australia' },
            { id: 'WA',  name: 'Western Australia' },
            { id: 'TAS', name: 'Tasmania' },
            { id: 'NT',  name: 'Northern Territory' },
            { id: 'ACT', name: 'Australian Capital Territory' },
          ],

          NZL: [
            { id: 'NTL', name: 'Northland' },
            { id: 'AUK', name: 'Auckland' },
            { id: 'WKO', name: 'Waikato' },
            { id: 'BOP', name: 'Bay of Plenty' },
            { id: 'GIS', name: 'Gisborne' },
            { id: 'HKB', name: "Hawke's Bay" },
            { id: 'TKI', name: 'Taranaki' },
            { id: 'MWT', name: 'Manawatū-Whanganui' },
            { id: 'WGN', name: 'Wellington' },
            { id: 'NSN', name: 'Nelson' },
            { id: 'MBH', name: 'Marlborough' },
            { id: 'TAS', name: 'Tasman' },
            { id: 'WTC', name: 'West Coast' },
            { id: 'CAN', name: 'Canterbury' },
            { id: 'OTA', name: 'Otago' },
            { id: 'STL', name: 'Southland' },
          ]
        },
        listTimeWindows: [],
        liteDates: [],
        valid: true,
        tagsList: [],
        newTag: {
          type: 'Serial',
          number: null,
          item: null,
          description: null,
          quantity: 1,
        },
        tagHeaders: [
          {text: 'Type', value: 'type', align: 'center', sortable: true},
          {text: 'Number', value: 'number', align: 'center', sortable: true},
          {text: 'Item', value: 'item', align: 'center', sortable: true},
          {text: 'Description', value: 'description', align: 'center', sortable: true},
          {text: 'Quantity', value: 'quantity', align: 'center', sortable: true},
          {text: 'Actions', value: 'actions', sortable: false, align: 'center'},
        ],
        addItemDialog: false,
        isEditing: false,
        focusedTag: null,
        deliveryCreated: false,
        createdTracking: null
      }
    },
    methods: {
      getTimeWindows(){
        if (this.selectedClient === null) return [];
        if (!this.postcode || this.postcode.length < 4) return [];
        axios.get(process.env.API_URL + '/deliveries/optionsadv?client_id=' + this.selectedClient + '&postcode=' +
          '&suburb=' + this.delivery.suburb + this.postcode + '&max_options=20')
          .then((response) => {
            console.log('default');
            if (response.status === 200) {
              console.log('Available Time windows found');
              if (response.data.length > 0) {
                this.defaultTimeWindowFound = true;
                this.listTimeWindows =  response.data.map((tw) => {
                  tw.id = tw.timewindow_id;
                  tw.display = 'From ' + tw.time_start + ' - To ' + tw.time_end;
                  return tw;
                });

                this.liteDates = this.listTimeWindows.map((tw) => {return tw.date});
                this.$refs.date[0].setDate(this.liteDates[0]);
                this.date = this.liteDates[0];
                return this.newTimeWindow;
              } else {
                this.newTimeWindow = null;
              }
            } else {
              console.log('No available time window');
            }
          })
          .catch((error) => {
            console.log(error);
          })
      },
      allowedDates(val){
        return this.liteDates.includes(val);
      },
      createDelivery(){
        if (this.$refs.form.validate()){
          console.log('creation proceeded');
          const response = {};
          let isCompleted = true;
          let missingPart = '';
          response['client_id'] = this.selectedClient;
          this.creationOption.forEach( parts => {
            parts.items.forEach( itemGroup => {
              itemGroup.forEach( item => {
                if (item.id === 'date'){
                  response[ 'date' ] = this.date;
                } else if (item.id === 'postcode'){
                  response[ 'postcode' ] = this.postcode;
                } else if (item.id === 'service_id'){
                  response[ 'service_id' ] = parseInt(item.value);
                } else if (item.id === 'tags'){
                  // Create a new array with the added properties, leaving the original tagsList untouched
                  const tagsForPayload = this.tagsList.map(tag => ({
                    ...tag, // Copy all existing properties from the original tag object
                    consolidation_depot_id: this.consolidation_depot_id,
                    production_date: this.production_date,
                  }));
                  // Assign the new, transformed array to the response
                  response['tags'] = tagsForPayload;
                } else if (item.id === 'timeWindow'){
                  response[ 'time_window_start' ] = item.value.time_start;
                  response[ 'time_window_end' ] = item.value.time_end;
                } else if (item.id === 'consolidation_depot' || item.id === 'production_date'){
                  // do nothing
                } else {
                  response[ item.id ] = item.value;
                  if ((!item.value || item.value === '') && item.required){
                    missingPart = missingPart + ', ' + item.id;
                    isCompleted = false;
                  }
                }

                // linehaul - if (consolidation_depot_id !== $zone->depot_id) $use_linehaul = true;
                response['use_linehaul'] = true;
              });
            });
          });
          if (isCompleted){
            axios.post(process.env.API_URL + '/deliveries/create', response)
              .then((response) => {
                this.$store.commit('displaySnackbar', 'Delivery created successfully');
                this.deliveryCreated = true;
                this.createdTracking = response.data.tracking;
                return response.data;
              })
              .catch((err) => {
                console.error("Caught Axios Error:", err); // Log the full error object for inspection

                let errorMessage = 'An unexpected error occurred while creating the delivery.'; // Default message

                if (err.response) {
                  // The request was made and the server responded with a status code outside the 2xx range
                  console.error("Error Response Data:", err.response.data);
                  console.error("Error Response Status:", err.response.status);

                  // --- Attempt to extract the specific error message ---
                  if (err.response.data && err.response.data.error) {
                    // Use the 'error' field from the JSON response
                    errorMessage = err.response.data.error;
                  } else if (typeof err.response.data === 'string' && err.response.data.length > 0) {
                    // Handle cases where the error response is just plain text
                    errorMessage = err.response.data;
                  } else if (err.message) {
                    // Fallback to the general Axios error message if specific data is missing
                    errorMessage = err.message;
                  }
                  // You could add more specific checks based on err.response.status if needed

                } else if (err.request) {
                  // The request was made but no response was received (e.g., network error, CORS)
                  console.error("Error Request:", err.request);
                  errorMessage = 'Could not connect to the server. Please check your network connection.';
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.error('Error:', err.message);
                  errorMessage = err.message; // General JS error before request was sent
                }

                // Commit the extracted or default error message to the store
                this.$store.commit('displaySnackbar', 'ERROR: ' + errorMessage);
                this.$store.commit('displayDialog', 'ERROR: ' + errorMessage);

                // Original code returned []; decide if that's still needed or if throwing is better
                // return Promise.reject(err); // Option: re-throw to allow further error handling
                return []; // Keep original behavior
              });
          } else {
            this.$store.commit('displaySnackbar', 'ERROR : missing' + missingPart.slice(1));
          }
        }
      },
      closeDialog(){
        for (let item in this.newTag){
          this.newTag[item] = null;
        }
        this.isEditing = false;
        this.focusedTag = null;
        this.addItemDialog = false;
      },
      editTag(item){
        this.focusedTag = this.tagsList.indexOf(item);
        this.isEditing = true;
        Object.assign(this.newTag, item);
        console.log(this.newTag);
        this.addItemDialog = true;
      },
      deleteTag(item){
        this.tagsList.splice(this.tagsList.indexOf(item), 1);
      },
      saveChanges(){
        this.newTag.type = 'Serial';
        if (this.isEditing){
          this.tagsList.splice(this.focusedTag, 1, Object.assign({}, this.newTag));
        } else {
          this.tagsList.push(Object.assign({}, this.newTag));
        }
        this.closeDialog();
      },

      createNewDelivery() {
        location.reload();
      },

      goToCreatedDelivery() {
        this.$router.push({ path: '/search?tracking=' + this.createdTracking });
      }
    },
    computed: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      renderedAvailableTimeWindows(){
        if (this.setAvailableTimeWindows === undefined || this.setAvailableTimeWindows === null) return [];
        return this.setAvailableTimeWindows;
      },
      renderedServices(){
        if (this.Services === undefined || this.Services === null) return [];
        return this.Services;
      },
      renderedDepots(){
        if (this.Depots === undefined || this.Depots === null || this.regions === undefined || this.regions === null || this.regions == []) return [];
        return this.Depots.filter(depot => this.regions.filter(region => region.country === this.country).some(region => region.id === depot.region_id));
      },
      clientsRendered() {
        if (this.clients === undefined || this.clients === null) return [];
        if (this.isInternalUser) {
          return [{'id': 0, 'name': 'Be Cool Couriers'}].concat(this.clients)
        } else return this.clients;
      },
      selectedClient() {
        if (this.isInternalUser) return this.clientId;
        else return this.$store.getters['auth/client_id'];
      },
      selectedClientObject() {
        return this.clientsRendered.find(client => client.id === this.selectedClient);
      },
    },
    asyncComputed: {
      async clients() {
        if (!this.isInternalUser) return [];
        return await axios.get(process.env.API_URL + '/clients')
          .then((response) => {
            // exclude pick-pack clients
            const data = response.data = response.data.filter(client => !client.pick_pack);
            return Object.values(data).sort((a, b) => (a.name > b.name) ? 1 : -1);
          })
          .catch((error) => {
            alert("An unknown error has occurred (Couldn't get clients...)");
            return [];
          })
      },
      async Services(){
        if (this.selectedClient === null) return [];
        return await axios.get(process.env.API_URL + '/services?client_id=' + this.selectedClient)
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            alert("An unknown error has occurred (Couldn't get clients...)");
            return [];
          })
      },
      async Depots(){
        return axios.get(process.env.API_URL + '/depots')
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            alert("An unknown error has occurred (Couldn't get depots...)");
            return [];
          })
      },
      async setAvailableTimeWindows(){
        console.log('setAvailableTimeWindows');
        if (this.date){
          this.availableTimeWindows = this.listTimeWindows.filter(tw => tw.date === this.date);
        } else {
          this.availableTimeWindows = [];
        }
        return this.availableTimeWindows;
      },

      async regions(){
        return await axios.get(process.env.API_URL + '/regions')
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            alert("An unknown error has occurred (Couldn't get regions...)");
            return [];
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/CreateDelivery/CreateDelivery.vue